import React from 'react';

const AppContext = React.createContext({
  user: null,
  loading: false,
  collapsed: false,
  search: 'test',
  categories: [],
  objectives: [],
  partners: [],
  searchFilter: 'test',
  searchFilterTypeOfAssign: 'test',
  setAppState() {},
});

export const useAppContext = () => React.useContext(AppContext);

export default AppContext;
